<template>
    <button class="button" @click.prevent="$emit('click')">
        <i class="icon-xl" :class="icon" aria-hidden="true" />
    </button>
</template>
<script>
    export default {
        name: 'NccToolbarIcon',
        props: {
            icon: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
  .button {
    color: #fff;
    cursor: pointer;
    border: 0;
    background-color: transparent;
    outline: none;
    padding: 0;
  }

  .button--active,
  .button:not(.button--disabled):hover {
    color: var(--primary);
  }

  .button--disabled {
    cursor: default;
    opacity: .25;
  }
</style>
